'use strict';

var _io = require('./internal/io');

module.exports = {
  take: _io.take,
  put: _io.put,
  race: _io.race,
  call: _io.call,
  apply: _io.apply,
  cps: _io.cps,
  fork: _io.fork,
  join: _io.join,
  cancel: _io.cancel,
  select: _io.select
};